import {
  BadgeCheck,
  AlertTriangle,
  LucideIcon,
  CheckCircle,
  CircleDashed,
} from 'lucide-react';
import { StatusFilterType } from '../components/MoldList/types';
import { styleConfig } from './design';

export interface StatusConfig {
  id: StatusFilterType;
  /** Default fallback label - will be overridden by statusLabelMapping */
  label: string;
  icon: LucideIcon;
  color: string;
  textColor: string;
  hoverColor: string;
  countBg: string;
}

/**
 * Base configuration for status filters
 * Labels are fallback values - actual labels should come from AppState's statusLabelMapping
 */
export const STATUS_FILTER_CONFIG: StatusConfig[] = [
  {
    id: 'ALL',
    label: 'สถานะทั้งหมด', // Special case - not in statusLabelMapping
    icon: BadgeCheck,
    color: 'bg-blue-100',
    textColor: 'text-blue-800',
    hoverColor: 'hover:bg-blue-200',
    countBg: 'bg-blue-50',
  },
  {
    id: 'ACTIVE',
    label: 'active', // Will be replaced by statusLabelMapping
    icon: CheckCircle,
    color: 'bg-green-100',
    textColor: 'text-green-800',
    hoverColor: 'hover:bg-green-200',
    countBg: 'bg-green-50',
  },
  {
    id: 'IN_SERVICING',
    label: 'in_servicing', // Will be replaced by statusLabelMapping
    icon: CircleDashed,
    color: 'bg-amber-100',
    textColor: 'text-amber-800',
    hoverColor: 'hover:bg-amber-200',
    countBg: 'bg-amber-50',
  },
  {
    id: 'ATTENTION_REQUIRED',
    label: 'ต้องการการดูแล', // Special case - not a mold status
    icon: AlertTriangle,
    color: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    hoverColor: 'hover:bg-yellow-200',
    countBg: 'bg-yellow-50',
  },
  {
    id: 'ARRIVING',
    label: 'arriving', // Will be replaced by statusLabelMapping
    icon: styleConfig.moldAcceptance.icon,
    color: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    hoverColor: 'hover:bg-yellow-200',
    countBg: 'bg-yellow-50',
  },
  {
    id: 'INACTIVE',
    label: 'inactive', // Will be replaced by statusLabelMapping
    icon: CircleDashed,
    color: 'bg-red-100',
    textColor: 'text-red-800',
    hoverColor: 'hover:bg-red-200',
    countBg: 'bg-red-50',
  },
  {
    id: 'RELEASED_TO_EXTERNAL',
    label: 'released_to_external', // Will be replaced by statusLabelMapping
    icon: CircleDashed,
    color: 'bg-sky-100',
    textColor: 'text-sky-800',
    hoverColor: 'hover:bg-sky-200',
    countBg: 'bg-sky-50',
  },
];
